<template>
 <div class="cooperation">
  <div class="cooperation-title cooperation_box">合作伙伴</div>
  <div class="cooperation-content animated_changtu cooperation_box">
   <div v-for="(item, index) in dataList" :key="index" class="cooperation-content-item">
    <img :src="getImgUrl(item)" alt="">
    <span>{{ item.input988275a1 }}</span>
   </div>
  </div>
  <div class="cooperation-pagination cooperation_box">
   <learnmore path="/price"></learnmore>
  </div>
 </div>
 <div class="cooperation-mobile">
  <div class="cooperation-title cooperation_box">合作伙伴</div>
  <div class="cooperation-content-mobile ">
   <div v-for="(item, index) in dataList" :key="index" class="cooperation-content-item-mobile">
    <img :src="getImgUrl(item)" alt="" style="width: 50px; height: 37px;">
    <span>{{ item.input988275a1 }}</span>
   </div>
  </div>
  <div class="cooperation-pagination cooperation_box">
   <learnmore path="/price"></learnmore>
  </div>
 </div>
</template>

<script setup>
import learnmore from "@/components/learnmore.vue"
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import ScrollReveal from 'scrollreveal'
const dataList = ref([])



const getImgUrl = (item) => {
 if (item['picture-uploada0bd83ed'] && item['picture-uploada0bd83ed'].length > 0) {
  return item['picture-uploada0bd83ed'][0].url
 } else {
  return ""

 }
}

const getTitle = (props) => {
 let info = dataList.value[props.i]
 if (info) {
  return info['input988275a1']
 } else {
  return ""
 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 28,
  sortField: "number4d19687a",
  isAsc: false,
  worksheetId: "681abcab515de26d772617d5",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataList.value = res.data
 }
}

onMounted(() => {
 getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 200,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".cooperation_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .cooperation {
  display: none !important;
 }

 .cooperation-mobile {
  display: flex !important;
 }
}



@media screen and (min-width: 800px) {
 .cooperation {
  display: flex !important;
 }

 .cooperation-mobile {
  display: none !important;
 }
}

.cooperation {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 800px;
 background: url("../../assets/image/cooperation_background.png") no-repeat;
 background-size: 100% 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
}

.cooperation-content {
 width: 1400px;
 height: 600px;
 border-radius: 10px;
}

.cooperation-title {
 font-size: 36px;
 font-weight: 500;
 color: #333333;
 margin: 30px 0;
}

.cooperation-pagination {
 display: flex;
 flex-direction: column;
 align-items: center;
}

.cooperation-content {
 display: flex;
 flex-wrap: wrap;
 justify-content: space-between;
 align-items: center;
}

.cooperation-content-item {
 width: 180px;
 height: 93px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 background: #FFFFFF;
 box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, .1);
 border-radius: 4px;
}

.cooperation-content-item-mobile {
 width: 28rem;
 height: 93px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 margin: 10px 0;
 background: #FFFFFF;
 box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, .1);
 border-radius: 4px;
}

.cooperation-mobile {
 font-family: 'PuHuiTi';
 width: 100%;

 display: flex;
 flex-direction: column;
 align-items: center;
}

.cooperation-content-mobile {
 width: 100%;
 padding: 0 10px;
 display: flex;
 justify-content: space-around;
 flex-wrap: wrap;
}
</style>